import { Route, Routes } from 'react-router-dom';
import './App.css';
import React from 'react';
import NotFoundPage from "./pages/NotFoundPage";
import Index from "./pages/Index";


function App() {

  return (
    <>
      <Routes>
        <Route path='/:code' element={<Index/>} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;